import { Separator } from '@cuemath/comps';
import React from 'react';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardMeta,
  Icon,
} from 'semantic-ui-react';
import { MODAL_NAMES } from './utils';
import { BUTTON_CONFIG, BUTTON_TYPES, STATUS_TYPES } from './button-config';
import { Text } from '@cuemath/web-comps';
import COLORS from '../../constants/colors';

const Actions = ({
  onEditDetails,
  editData,
  onSendConfirmationEmail,
  openModal,
  status,
  timezone,
  studentName,
  grade,
  cnaData,
  confirmedOn,
}) => {
  const onAddCustomerNeeds = React.useCallback(() => {
    openModal(MODAL_NAMES.addCustomerNeeds);
  }, [openModal]);

  const onEditCustomerNeeds = React.useCallback(() => {
    openModal(MODAL_NAMES.editCustomerNeeds);
  }, [openModal]);

  const onCancelTrial = React.useCallback(() => {
    openModal(MODAL_NAMES.cancelTrial);
  }, [openModal]);

  const handleAssignSlot = React.useCallback(() => {
    openModal(MODAL_NAMES.assignSlot);
  }, [openModal]);

  const handleRescheduleSlot = React.useCallback(() => {
    openModal(MODAL_NAMES.rescheduleSlot);
  }, [openModal]);

  const handleRescheduleSlotSameTutor = React.useCallback(() => {
    openModal(MODAL_NAMES.rescheduleSlotSameTutor);
  }, [openModal]);

  const handleRescheduleSlotDifferentTutor = React.useCallback(() => {
    openModal(MODAL_NAMES.rescheduleSlotDifferentTutor);
  }, [openModal]);

  const allowedButtons = BUTTON_CONFIG[status] || [];
  const canAssignSlots =
    grade && timezone && studentName && cnaData && Object.keys(cnaData)?.length !== 0;
  const canShowAddCustomerNeedsBtn =
    !cnaData || (cnaData && Object.keys(cnaData)?.length === 0);

  return (
    <Card fluid>
      <CardContent>
        <CardHeader>Available Actions</CardHeader>
        <CardMeta>Choose an action to perform for this lead</CardMeta>
        <br />
        <CardDescription>
          {allowedButtons.includes(BUTTON_TYPES.ASSIGN_SLOTS) && (
            <>
              <Button
                icon
                fluid
                labelPosition="left"
                size="large"
                color="black"
                onClick={handleAssignSlot}
                disabled={!canAssignSlots}
              >
                <Icon name="plus" /> Assign Slot
              </Button>
              {!canAssignSlots ? (
                <>
                  <Separator height={8} transparent />
                  <Text variant="body3" color={COLORS.RUSTY_RED}>
                    Student details and CNA details are required to assign slot
                  </Text>
                </>
              ) : null}
              <Separator height={16} transparent />
            </>
          )}
          {allowedButtons.includes(BUTTON_TYPES.SEND_CONFIRMATION_LINK) && (
            <>
              <Button
                icon
                basic
                fluid
                labelPosition="left"
                size="large"
                onClick={onSendConfirmationEmail}
              >
                <Icon name="mail" /> Send Confirmation Link
              </Button>
              <Separator height={16} transparent />
            </>
          )}
          {allowedButtons.includes(BUTTON_TYPES.ADD_CUSTOMER_NEEDS) &&
            canShowAddCustomerNeedsBtn && (
              <>
                <Button
                  icon
                  basic
                  fluid
                  labelPosition="left"
                  size="large"
                  onClick={onAddCustomerNeeds}
                >
                  <Icon name="user outline" /> Add Customer Needs
                </Button>
                <Separator height={16} transparent />
              </>
            )}
          {allowedButtons.includes(BUTTON_TYPES.EDIT_CUSTOMER_NEEDS) &&
            !canShowAddCustomerNeedsBtn && (
              <>
                <Button
                  icon
                  basic
                  fluid
                  labelPosition="left"
                  size="large"
                  onClick={onEditCustomerNeeds}
                >
                  <Icon name="edit outline" /> Edit Customer Needs
                </Button>
                <Separator height={16} transparent />
              </>
            )}
          {allowedButtons.includes(BUTTON_TYPES.RESCHEDULE_TRIAL) &&
            (status !== STATUS_TYPES.TRIAL_CANCELLED ||
              (status === STATUS_TYPES.TRIAL_CANCELLED && !confirmedOn)) && (
              <>
                <Button
                  icon
                  basic
                  fluid
                  labelPosition="left"
                  size="large"
                  onClick={handleRescheduleSlot}
                >
                  <Icon name="redo" /> Reschedule Trial
                </Button>
                <Separator height={16} transparent />
              </>
            )}
          {allowedButtons.includes(BUTTON_TYPES.RESCHEDULE_TRIAL_SAME_TUTOR) && (
            <>
              <Button
                icon
                basic
                fluid
                labelPosition="left"
                size="large"
                onClick={handleRescheduleSlotSameTutor}
              >
                <Icon name="redo" /> Reschedule Trial (Same Tutor)
              </Button>
              <Separator height={16} transparent />
            </>
          )}
          {allowedButtons.includes(BUTTON_TYPES.RESCHEDULE_TRIAL_DIFFERENT_TUTOR) &&
            (status !== STATUS_TYPES.TRIAL_CANCELLED ||
              (status === STATUS_TYPES.TRIAL_CANCELLED && confirmedOn)) && (
              <>
                <Button
                  icon
                  basic
                  fluid
                  labelPosition="left"
                  size="large"
                  onClick={handleRescheduleSlotDifferentTutor}
                >
                  <Icon name="redo" />{' '}
                  {status === STATUS_TYPES.TRIAL_CONFIRMED ||
                  status === STATUS_TYPES.TRIAL_CANCELLED
                    ? 'Reschedule Trial'
                    : 'Reschedule Trial (Different Tutor)'}
                </Button>
                <Separator height={16} transparent />
              </>
            )}
          {!editData.canEditData &&
            allowedButtons.includes(BUTTON_TYPES.EDIT_LEAD_DETAILS) && (
              <>
                <Button
                  icon
                  basic
                  fluid
                  labelPosition="left"
                  size="large"
                  onClick={onEditDetails}
                >
                  <Icon name="edit outline" />
                  Edit Lead Details
                </Button>
                <Separator height={16} transparent />
              </>
            )}
          {allowedButtons.includes(BUTTON_TYPES.CANCEL_TRIAL) && (
            <>
              <Button
                negative
                icon
                fluid
                labelPosition="left"
                size="large"
                onClick={onCancelTrial}
              >
                <Icon name="close" /> Cancel Trial
              </Button>
              <Separator height={16} transparent />
            </>
          )}
        </CardDescription>
      </CardContent>
    </Card>
  );
};

export default Actions;
